/* Functionality that is shared by all "assets" (things with a
   geometry that can have timeseries attached to them) */

/* In the backend, assets have the base classes "CodedGeoModel" and
   "HasTimeseriesModel", and they use "AssetSerializer", which
   gives them certain shared fields. It makes sense to define
   those here. */

/* However geometry types (points, lines, polygons) differ between
   asset types and can be overwritten in their individual files.
   Most common is "Point" and that is defined here as default. */

import { z } from "zod";

import { lizardDateSchema } from "../dates";
import { pointSchema } from "../geojson";

import { organisationSchema } from "./organisations";

export const baseModelSchema = z.object({
  last_modified: lizardDateSchema.nullable(),
  created: lizardDateSchema,
});

export const baseAssetSchema = baseModelSchema.extend({
  url: z.string(),
  id: z.number(),
  code: z.string(),
  organisation: organisationSchema,
  geometry: pointSchema,
  image_url: z.string().nullable(),
});

export const baseAssetWithTimeseriesSchema = baseAssetSchema.extend({
  timeseries: z.array(z.string()),
});
